// extracted by mini-css-extract-plugin
export default {"profileWrapper":"profile-styles_profileWrapper__QWT77","profileInfo":"profile-styles_profileInfo__TLDsT","userInfoWrapper":"profile-styles_userInfoWrapper__Gg6bi"};